<template>
  <el-container class="route-tab">
    <el-row style="padding-left: 10px;">
      <RouteCreate v-if="createForm" @cancelled="createForm=false" @created="createForm=false" />
    </el-row>
    <el-row style="padding-left: 10px;">
      <el-button v-if="checkPermission('createRoute') && !createForm" data-v-step="routes" style="margin-top: 5px;" @click="createForm=true" >{{$t('routes.createroutes')}}</el-button>
    </el-row>
    <br />
    <el-row>
      <div class="route-container">
        <RouteView class="route" v-for="route in routes" :key="route._id" :route="route" />
      </div>
    </el-row>
  </el-container>
</template>

<script>
import RouteCreate from "./Route_Create";
import RouteView from "./Route_View";

import { mapState, mapActions } from "vuex";
export default {
  name: "RouteTab",
  components: { RouteCreate, RouteView },
  data() {
    return {
      createForm: false,
    };
  },
  computed: {
    ...mapState("account", ["activeTab"]),
    ...mapState("route", ["routes"]),
  },
  methods: {
    ...mapActions("tree", ["updateConfig"])
  },
  watch: {
    activeTab(c) {
      if (c == "routes") {
        this.updateConfig({
          showCheckbox: true,
        });
      }
    },
  },
};
</script>

<style scoped>
.route-container {
  /* We first create a flex layout context */
  display: flex;

  flex-flow: row wrap;
  /* Then we define how is distributed the remaining space */
}

.route {
  flex: 0 1 auto;
}
.route-tab {
  flex-direction: column;
  flex: 1;
  display: flex;
  overflow: auto;
}
</style>